import React, { useContext, useEffect } from 'react';
import { AppShell, Badge, Drawer, Group, ScrollArea } from '@mantine/core';
import { Outlet, Route, Routes, useNavigate } from 'react-router-dom';
import { useDisclosure } from '@mantine/hooks';
import Search from '../../pages/Search';
import Evidence from '../../pages/Evidence';
import Rankings from '../../pages/Rankings';
import PathExplorer from '../../pages/PathExplorer';
import { NavLink } from '../../components/Navigation/NavLink';
import Header from '../../components/Navigation/Header';
import { FaAnglesLeft, FaAnglesRight } from 'react-icons/fa6';
import { MdBarChart } from 'react-icons/md';
import { RiPuzzle2Fill } from 'react-icons/ri';
import UiStateContext from '../../providers/UiStateProvider';
import { nodeTypes, Stages } from '../../types';
import MeshTable from '../Mesh/MeshTable';
import { PiGraphBold } from 'react-icons/pi';
import UserSelectionContext from '../../providers/UserSelectionProvider';
import { getHardcodedColor } from '../../utils';

export function CustomAppShell() {
    const { meshPanelOpened, setCurrentStage, currentStage, SwitchMeshPanelOpened } = useContext(UiStateContext)
    const { selectedMoa } = useContext(UserSelectionContext)
    const [mobileOpened] = useDisclosure();
    const [desktopOpened, { toggle: toggleDesktop }] = useDisclosure(true);
    const navigate = useNavigate();

    useEffect(() => {
        if (!selectedMoa && window.location.pathname !== '/app') {
            navigate('/app');
        }
        if (selectedMoa && window.location.pathname === '/app') {
            navigate('/app/rankings');
        }
    }, [selectedMoa, navigate]);

    return (
        <AppShell
            padding="md"
            styles={{
                main: {
                    height: '100vh',
                    overflowY: 'auto',
                    background: 'white',
                },
            }}
            header={{ height: 100 }}
            transitionDuration={0}
            navbar={{
                width: !desktopOpened ? 52 : 250,
                breakpoint: 'sm',
                collapsed: { mobile: !mobileOpened },
            }}
        >
            <Header />
            <AppShell.Navbar style={{ backgroundColor: "#f3f3f7" }}>
                <AppShell.Section>
                    <NavLink
                        key={Stages.rankings}
                        stage={{
                            id: Stages.rankings,
                            name: "Rankings",
                            description: "rankings",
                            icon: MdBarChart
                        }}
                        open={desktopOpened}
                        active={currentStage === Stages.rankings}
                        disabled={!selectedMoa}
                        onClick={() => { setCurrentStage(Stages.rankings) }}
                    />
                    <NavLink
                        key={Stages.evidence}
                        stage={{
                            id: Stages.evidence,
                            name: "Evidence",
                            description: "evidence",
                            icon: RiPuzzle2Fill
                        }}
                        open={desktopOpened}
                        active={currentStage === Stages.evidence}
                        disabled={!selectedMoa}
                        onClick={() => { setCurrentStage(Stages.evidence) }}
                    />
                    <NavLink
                        key={Stages.kg}
                        stage={{
                            id: Stages.kg,
                            name: "Path Explorer",
                            description: "Path Explorer",
                            icon: PiGraphBold
                        }}
                        open={desktopOpened}
                        active={currentStage === Stages.kg}
                        disabled={!selectedMoa}
                        onClick={() => { setCurrentStage(Stages.kg) }}
                    />
                    <Group style={{padding: 10}} gap={5}>
                        {currentStage === Stages.kg && desktopOpened && Object.values(nodeTypes).map((nt) => (
                        <Badge variant='dot' color={getHardcodedColor(nt)}>{nt}</Badge>))
                        }
                    </Group>
                </AppShell.Section>
                <AppShell.Section
                    style={{
                        width: '100%',
                        borderTop: '1px solid #e4e4e6',
                        position: 'absolute',
                        bottom: '0px',
                    }}
                >
                    <NavLink
                        key="collapse"
                        stage={{
                            id: undefined,
                            name: "Collapse",
                            description: "",
                            icon: desktopOpened ? FaAnglesLeft : FaAnglesRight
                        }}
                        open={desktopOpened}
                        active={false}
                        disabled={!selectedMoa}
                        onClick={toggleDesktop}
                    />
                </AppShell.Section>
            </AppShell.Navbar>
            <AppShell.Main>
                <ScrollArea>
                    <Outlet />
                </ScrollArea>
                {meshPanelOpened && (
                    <Drawer opened={meshPanelOpened} onClose={SwitchMeshPanelOpened} position="right" size="75rem" title="MeSH Disease Tree" transitionProps={{ transition: "fade" }}>
                        <MeshTable />
                    </Drawer>
                )}
            </AppShell.Main>
        </AppShell>
    );
}
